/**
 * 우리동네 크라우드 펀딩 관련
 */
const prefix = 'woori-crowd'
// prefix를 쓰면 오히려 라우터 검색이 어려운듯..?

export default [
  {
    path: `/woori-crowd`,
    component: () => import('@/pages/woori-crowd/Index.vue'),
    children: [
      {
        name: prefix,
        path: '',
        meta: {
          title: '우리동네 크라우드 펀딩 홈',
          design: { classes: ['full-height'] },
        },
        component: () => import('@/pages/woori-crowd/Main.vue'),
      },
      {
        name: `woori-crowd/detail`,
        path: `:uuid`,
        meta: {
          title: '신청 상세',
          design: { classes: ['bg--linear-gradient'] },
        },
        props: (route) => ({ uuid: route.params.uuid }),
        component: () => import(`@/pages/woori-crowd/RequestDetail.vue`),
      },
      {
        name: `woori-crowd/detail/application`,
        path: `:uuid/application`,
        meta: {
          title: '신청서 제출',
          design: { classes: [''] },
        },
        props: (route) => ({ uuid: route.params.uuid }),
        component: () => import(`@/pages/woori-crowd/Application.vue`),
      },
    ],
  },
]
